export const codeIsMissingAPrefix = (code) => code && code.includes('xxx');

export const applyPrefix = (prefix) => (code) => code.replace('xxx', prefix);
